// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
export const MoneyFragmentDoc = gql`
    fragment money on Money {
  __typename
  amount
  currency
}
    `;